// react core
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// components
import AjaxSpinner from 'components/commons/ajax_spinner';
// conf
import conf from 'conf/config'
// api
import { AUTH } from 'api/account';
import usePageTitle from 'utils/page_title';

export default function LogoutPage(props)
{

    const [logged_out, set_logged_out] = useState(false);
    usePageTitle(logged_out ? 'Logged Out' : 'Log Out');

    useEffect(() =>
    {
        let mounted = true;
        const send_data = async () =>
        {
            const response =  await AUTH.logout();
            if(response.ok)
            {
                const data = await response.json();
                if (mounted)
                {
                    if(data.status === 'ok')
                    {
                        props.set_user_data(
                        {
                        });
                        set_logged_out(true);
                    }
                }
            }
            else
            {
                console.error("server error");
            }
        }
        // call the function
        send_data()
        // make sure to catch any error
        .catch(console.error);
        return () => mounted = false; // cleanup function
    }, [props]);


    if(!logged_out)
    {
        return (
            <div id="content">
                <AjaxSpinner show={true} />
            </div>
        );
    }
    else
    {
        return (<>
                <h2>See you soon!</h2>
                <p>If you logged out by mistake, please <Link className="primary" to={conf.server.login}>Log In</Link></p>
                </>
        )
    }
};
